import { Component, ElementRef, HostBinding, HostListener, inject, OnChanges, SimpleChanges, input } from '@angular/core';
import { UserAgentService } from '@library/utils/services/user-agent.service';

@Component({
  selector: 'lay-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  standalone: false,
})
export class LinkComponent implements OnChanges {
  userAgent = inject(UserAgentService);
  private readonly el = inject(ElementRef);

  readonly resolve = input(true);

  readonly direction = input('row');

  public hasClick = false;
  public showSpinner = false;

  @HostBinding('class') classes = 'lay-link';
  @HostBinding('attr.role') role = 'link';
  @HostBinding('attr.tabindex') tabindex = '0';

  @HostListener('click', ['$event'])
  isLoadingButton(event) {
    if (!this.resolve()) {
      event.preventDefault();
      event.stopPropagation();
      this.showSpinner = true;
      this.hasClick = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.hasClick && changes.resolve && changes.resolve.currentValue) {
      this.el.nativeElement.click();
      this.showSpinner = false;
    }
  }
}
